export default __webpack_public_path__ + "static/media/ongoing2.2afb8a76.png";